export default __webpack_public_path__ + "static/media/hair-8-6.f8ea74ff.svg";